
<div class="container visible-xs  mb-3" >
  <div class=" pl-1 pt-2 footer_font" *ngIf="!showTermsofUseText">
    <div [innerHTML]="termsOfUseText"></div>
    
    <!-- {{'home.copyright.footerTextBeforeHyperlink' | cxTranslate}} 
    <a href="{{termsOfUseStr}}" target="_blank">{{'home.copyright.termsOfUse' | cxTranslate }}</a> 
    {{'home.copyright.footerTextAfterHyperlink' | cxTranslate}}  -->
  </div>
  <div class="d-flex justify-content-between pl-1 pt-2">
    <div>
      <a href={{securityNoLink}}  target="_blank"*ngIf="chinaInstance==='true'"><small><img src="/images/icon9652 1.svg" alt="icon" width="16px" height="12px" style="margin-right: 2px;">
        {{'home.copyright.firstSlotData1' | cxTranslate }}{{securityNum}}{{'home.copyright.firstSlotData2' | cxTranslate }}</small></a>
    </div>
    <div >
      <a href={{ICPNoLink}} *ngIf="chinaInstance==='true'"  target="_blank"><small>{{'home.copyright.secondSlotData1' | cxTranslate }}{{icpNum}}{{'home.copyright.secondSlotData2' | cxTranslate }}</small></a>
    </div>
    <div class="d-flex">
      <div class="mr-3 d-none">
        <small>{{'home.copyright.accessibility' | cxTranslate }}</small>
      </div>
      <div class="mr-3">
        <small [hidden]="currentRoute == '/login' ">{{'home.datePattern' | cxTranslate }}</small>
      </div>
      <div class="mr-3">
        <a href="{{CookiePolicyLink}}" target="_blank"><small>{{'home.copyright.cookiesPolicy' | cxTranslate }}</small></a>
      </div>
      <div class="mr-3">
        <!-- <a href="https://www.bhp.com/privacy-policy" target="_blank"><small>{{'home.copyright.privacyPolicy' | cxTranslate }}</small></a> -->
        <a href="{{privacyPolicyStr}}" target="_blank"><small>{{'home.copyright.privacyPolicy' | cxTranslate }}</small></a>
      </div>
      <div class="mr-3">
       <!-- <a href="https://www.bhp.com/terms-of-use" target="_blank"><small>{{'home.copyright.termsOfUse' | cxTranslate }}</small></a>  -->
       <a href="{{termsOfUseStr}}" target="_blank"><small>{{'home.forgotPassword.buyertermsofUse' | cxTranslate }}</small></a> 
      </div>
      <div class="mr-3" *ngIf="chinaInstance==='true'">
        <!-- <a href="https://www.bhp.com/terms-of-use" target="_blank"><small>{{'home.copyright.termsOfUse' | cxTranslate }}</small></a>  -->
        <a href="{{termsOfUsePartner}}" target="_blank"><small>{{'home.copyright.termsOfUsePartner' | cxTranslate }}</small></a> 
       </div>
      <div class="mr-3">
        <small>{{copyrightInfo}}</small>
      </div>
  </div>
</div>
</div>
<div class="container d-lg-none remove-extra-space">
<!-- <div class="hr"></div> -->
 <div class="help-support-wrapper mt-4" *ngIf="currentRoute !== '/login' && currentRoute !== '/login/forgot-password' && currentRoute !== '/login/otp'">
  <a [routerLink]="['/help']" class="help-support-btn">
    <i class="fa fa-question-circle" aria-hidden="true"></i>
    {{'home.headerLinks.help&support' | cxTranslate}}
  </a>
</div>
<div class="footer_font mt-3" *ngIf="!showTermsofUseText">
  <div [innerHTML]="termsOfUseText"></div>
</div>

<div class="d-flex justify-content-between pt-2">
  <small [hidden]="currentRoute == '/login'">{{'home.datePattern' | cxTranslate }}</small>
</div>
<div>
  <div class="d-none"><small>{{'home.copyright.accessibility' | cxTranslate }}</small></div>
  <div ><a class="tag" href="{{CookiePolicyLink}}"><small>{{'home.copyright.cookiesPolicy' | cxTranslate }}</small></a></div>
  <div ><a class="tag" href="{{privacyPolicyStr}}" target="_blank"><small>{{'home.copyright.privacyPolicy'  | cxTranslate }}</small></a></div>
  <div ><a class="tag" href="{{termsOfUseStr}}" target="_blank"><small>{{'home.forgotPassword.buyertermsofUse' | cxTranslate }}</small></a></div>
  <div ><a class="tag" href="{{termsOfUsePartner}}" target="_blank"><small>{{'home.copyright.termsOfUsePartner' | cxTranslate }}</small></a></div>
  <div><small>{{copyrightInfo}}</small></div>
</div>
<div class="hr hidden-ipad"></div>
  <div class="d-flex justify-content-between" *ngIf="chinaInstance==='true'">
    <div  >
      <a href={{securityNoLink}} target="_blank" class='text-center'><small><img src="/images/icon9652 1.svg" alt="icon" width="16px" height="12px" style="margin-right: 2px;">{{'home.copyright.firstSlotData1' | cxTranslate }}{{securityNum}}{{'home.copyright.firstSlotData2' | cxTranslate }}</small></a>
    </div>
    <div >
      <a href={{ICPNoLink}} target="_blank"><small>{{'home.copyright.secondSlotData1' | cxTranslate }}{{icpNum}}{{'home.copyright.secondSlotData2' | cxTranslate }}</small></a>
    </div>
  </div>
  <div class="bottom-margin">
  </div>
